<template>
  <Button
    variant="text"
    severity="secondary"
    rounded
    v-tooltip.bottom="$t('mcpConnect.tooltip')"
    :aria-label="$t('mcpConnect.tooltip')"
    data-telemetry-id="btn-mcp-connect"
    @click="open = true"
  >
    <template #icon>
      <span class="material-icons select-none" style="font-size: 24px" aria-hidden="true">electrical_services</span>
    </template>
  </Button>
  <McpConnectDialog v-model:visible="open" />
</template>

<script setup>
/**
 * McpConnectButton.vue
 *
 * Header icon button that opens the MCP connection dialog (McpConnectDialog).
 * No props or events: the dialog's visibility is owned locally.
 *
 * @example
 * <McpConnectButton />
 */
import { ref } from 'vue';
import McpConnectDialog from './McpConnectDialog.vue';

const open = ref(false);
</script>
